const guiColors = {
    'motion-primary': 'var(--dash-accent-custom)',
    'motion-primary-transparent': 'var(--dash-accent-custom-motion-primary-transparent)',
    'motion-tertiary': 'var(--dash-accent-custom-dark)',

    'looks-secondary': 'var(--dash-accent-custom)',
    'looks-transparent': 'var(--dash-accent-custom-transparent)',
    'looks-light-transparent': 'var(--dash-accent-custom-light-transparent)',
    'looks-secondary-dark': 'var(--dash-accent-custom-dark)',

    'extensions-primary': 'var(--dash-accent-custom-extensions-primary)',
    'extensions-tertiary': 'var(--dash-accent-custom-extensions-tertiary)',
    'extensions-transparent': 'var(--dash-accent-custom-extensions-transparent)',
    'extensions-light': 'var(--dash-accent-custom-extensions-light)',

    'drop-highlight': 'var(--dash-accent-custom-drop-highlight)'
};

const blockColors = {
    checkboxActiveBackground: 'var(--dash-accent-custom)',
    checkboxActiveBorder: 'var(--dash-accent-custom-dark)'
};

export {
    guiColors,
    blockColors
};
